import cn from 'classnames';
import objToStyle from './stylesConverter';
import { getRootApi } from 'meta/utils/getRootApi';
import { getFormData } from './formDialogBuilder';
export class Dialog {
    promise;
    modal;
    returnValue;
    config;
    modalContent;
    keyboardButtons;
    activeElement;
    promiseResolve;
    promiseReject;
    static current;
    static modals = [];
    static targetDocument = document;
    static show = function (config) {
        let m = new Dialog(Object.assign({
            destroyOnHide: true,
            hideOnButtonClick: true
        }, config));
        Dialog.modals.push(m);
        if (m.modal) {
            let idx = Dialog.modals.indexOf(m);
            let positionMode = (config && config.position);
            if (idx > 0) {
                m.modal.style.background = 'transparent';
                positionMode = Dialog.modals[0].config.position;
            }
            let modalContent = m.modal.querySelector('.ui2-modal-content');
            m.show(config.onShow);
            switch (positionMode) {
                case 'center':
                    modalContent.style.top = `calc(50% + ${(idx * 5)}px)`;
                    modalContent.style.transform = 'translate(0, -50%)';
                    break;
                case 'top':
                default:
                    modalContent.style.top = `${25 + (idx * 5)}px`;
                    break;
            }
            modalContent.style.left = `${idx * 5}px`;
            modalContent.style.opacity = "1";
            m.promise.modal = m;
        }
        return m.promise;
    };
    constructor(config) {
        this.promise = new Promise((resolve, reject) => {
            this.promiseResolve = resolve;
            this.promiseReject = reject;
        });
        this.keyboardButtons = Object.assign({}, config.keyboardButtons);
        this.handleKeys = this.handleKeys.bind(this);
        this.config = config;
        this.modal = Dialog.targetDocument.createElement('div');
        this.modal.tabIndex = 0;
        this.modal.className = cn('ui2-modal', config.wrapInIframe ? 'iframe-modal' : null, config.className);
        this.modal.innerHTML = this._render();
        if (!config.hideCloseButton) {
            const closeButton = this.modal.querySelector('.ui2-close');
            closeButton.onclick = () => this.hide();
        }
        let form = this.modal.querySelector('.field-container');
        let footer = this.modal.querySelector('.ui2-modal-footer');
        for (let i in config.buttons) {
            let b = config.buttons[i];
            let btn = Dialog.targetDocument.createElement('button');
            btn.className = `ui2-btn ui2-btn-${b.type || 'primary'}${b.disabled ? ' disabled' : ''}`;
            btn.dataset["key"] = i;
            if (b.focus)
                btn.dataset["focus"] = "true";
            if (b.disabled)
                btn.disabled = true;
            btn.innerHTML = b.label ?? '';
            const clickHandler = () => {
                let result = b.callback
                    ? b.callback(getFormData(form), this)
                    : undefined;
                if (config.hideOnButtonClick)
                    this.hide(result);
            };
            btn.onclick = clickHandler;
            if (b.keyCode)
                this.keyboardButtons[b.keyCode] = clickHandler;
            footer.appendChild(document.createTextNode(' ')); // add whitespace to separate buttons from one another
            footer.appendChild(btn);
        }
        Dialog.targetDocument.body.appendChild(this.modal);
        this.modalContent = this.modal.querySelector('.ui2-modal-content');
    }
    _render() {
        let { config } = this;
        let { width, height } = config;
        let body;
        if (config.wrapInIframe) {
            let wrappIfr = Dialog.targetDocument.createElement('iframe');
            wrappIfr.src = 'data:text/html;charset=utf-8,' + encodeURI(config.body);
            body = wrappIfr.outerHTML;
        }
        else {
            body = config.body;
        }
        let html = `
            <div class="ui2-modal-content" style="${objToStyle({ width })}">
                <div class="ui2-modal-header">
                    <span class="ui2-modal-title">${config.title}</span>
                    ${config.hideCloseButton ? '' :
            `<button type="button" class="ui2-close" data-dismiss="modal" aria-label="Close">
                                <span class="fa fa-times" />
                          </button>`}
                </div>
                <div class="ui2-modal-body" style="${objToStyle({ height })}">
                    ${body}
                </div>
                ${config.buttons ? '<div class="ui2-modal-footer"></div>' : ''}
            </div>
        `;
        return html;
    }
    showMessage(message, type = 'danger') {
        if (this.modal) {
            let modalBody = this.modal.querySelector('.ui2-modal-body');
            $(this.modal).find('.ui2-modal-body .alert').remove();
            let messageEl = Dialog.targetDocument.createElement('p');
            messageEl.className = cn('alert', `alert-${type}`);
            messageEl.innerHTML = message;
            modalBody.appendChild(messageEl);
        }
    }
    destroy() {
        if (this.modal) {
            this.modal.removeEventListener('keydown', this.handleKeys);
            Dialog.targetDocument.body.removeChild(this.modal);
            this.modal = undefined;
            Dialog.modals.splice(Dialog.modals.indexOf(this), 1);
        }
    }
    handleKeys(e) {
        const keyCode = e.keyCode || e.which;
        if (this.keyboardButtons[keyCode])
            this.keyboardButtons[keyCode](e, this);
        if (keyCode === 9) {
            e.preventDefault();
            let $inputs = $('input:not([disabled]), textarea:not([disabled]), button.ui2-btn:not([disabled])', '.ui2-modal-content');
            const index = $inputs.index($(':focus'));
            let $next = $inputs[index + 1] || $inputs[0];
            $next.focus();
        }
        if (keyCode === 13 && this.keyboardButtons[13]) {
            e.stopPropagation();
            e.preventDefault();
        }
        if (keyCode === 27 && !this.config.hideCloseButton)
            this.hide(false);
    }
    show(cb) {
        if (this.modal) {
            this.activeElement = Dialog.targetDocument.activeElement ?? undefined;
            this.modal.style.display = "block";
            this.modal.tabIndex = 0;
            this.modal.addEventListener('keydown', this.handleKeys);
            // if any form element is present on modal, then the first one is focued after show
            const setFocus = () => {
                if (this.modal) {
                    this.modal.focus();
                    let formInput = this.modal.querySelector('input, textarea');
                    if (formInput) {
                        formInput.focus();
                        if ("select" in formInput) {
                            formInput.select();
                        }
                    }
                    else {
                        $('.ui2-modal-footer .ui2-btn', this.modal).focus();
                        $('.ui2-modal-footer .ui2-btn[data-key="OK"]', this.modal).focus();
                        $('.ui2-modal-footer .ui2-btn[data-focus]', this.modal).focus();
                    }
                }
            };
            setFocus();
            // when the dialog doesn't fit the screen, start scrolled to the top rather than to the buttons at the bottom
            this.modal.scrollTop = 0;
            if (cb) {
                cb(this);
            }
            $('textarea', this.modal).on('keydown', (e) => {
                if (e.keyCode === 13)
                    e.stopPropagation();
            });
            $('.ui2-modal-content', this.modal).draggable({
                handle: '.ui2-modal-header',
                start: () => $('.ui2-modal-content', this.modal).addClass('no-transition'),
                stop: () => {
                    $('.ui2-modal-content', this.modal).removeClass('no-transition');
                    if (this.modal) {
                        // give focus to the modal (we were dragging it, so it makes sense to have focus on it and not on the body of the root where jQuery draggable sets it)
                        this.modal.focus();
                    }
                }
            });
            Dialog.current = this;
        }
        return this.promise;
    }
    setTitle(titleHtml) {
        if (this.modal) {
            const title = this.modal.querySelector('.ui2-modal-title');
            title.innerHTML = titleHtml;
        }
    }
    hide(returnValue) {
        if (!this.modal)
            throw Error("Dialog has been already hidden!");
        this.modal.style.display = "none";
        this.modal.style.zIndex = "0";
        this.returnValue = returnValue;
        let ifr = this.modal.querySelector('iframe');
        if (ifr)
            this.returnValue = returnValue || ifr.contentWindow?.returnValue;
        let onHideParams = {};
        if (ifr && ifr.contentDocument) {
            let paramsField = ifr.contentDocument.querySelector('#dialogOnHideParameters');
            if (paramsField)
                onHideParams = JSON.parse(paramsField.value);
        }
        if (this.config.destroyOnHide)
            this.destroy();
        Dialog.current = undefined;
        if (this.activeElement && this.activeElement instanceof HTMLElement) {
            this.activeElement.focus();
        }
        if (this.promiseResolve) {
            this.promiseResolve(this.returnValue);
        }
        getRootApi().FrontendEvents.modalClosed();
        if (this.config.onHide)
            this.config.onHide(onHideParams);
    }
}
